import React from "react";
import { Group } from "react-konva";
import { ITaskController } from "../../controller";
import { TASK_HEIGHT_WITH_INFO } from "shared/datamodel/task";
import { TaskElementTags } from "./task-tags";
import { TaskElementAssignee } from "./task-assignee";
import useObservableController from "elements/hooks/use-observable-controller";

const WIDGET_ROW_HEIGHT = 24;
const BOTTOM_OFFSET = 12; // I don't know why we need this but it solves everything
const BOTTOM_MARGIN = 12;

export const TaskWidgets = React.memo(({ controller }: { controller: ITaskController }) => {
  useObservableController(controller, "size-changed");

  const { element } = controller;
  const { height = TASK_HEIGHT_WITH_INFO } = element;

  return (
    <Group y={height - WIDGET_ROW_HEIGHT - BOTTOM_OFFSET - BOTTOM_MARGIN}>
      <TaskElementTags controller={controller} />
      <TaskElementAssignee controller={controller} />
    </Group>
  );
});

TaskWidgets.displayName = "TaskWidgets";
